import styled from "@emotion/styled";
import { Section } from "../layout/section";
import { Link } from "gatsby";

const StyledPartners = styled.div`
	div {
		background-color: var(--off-white);
		padding: var(--large) var(--xx-small);
		text-align: center;

		& > * {
			margin: auto;
		}
	}

	.h2 {
		max-width: 630px;
	}

	p {
		max-width: 755px;
		margin: var(--mini) auto var(--xx-small);
	}
`;

export const Partners = () => (
	<Section>
		<StyledPartners className="row">
      <div>
        <h2 className="h2">White Label SEO Partners We Teamed Up With</h2>
        <p>
          We use a myriad of SEO softwares and tools to achieve optimal results
          for your clients with our white label SEO options. Here are just a few
          of the partners we’ve teamed with for optimal results.
        </p>
        <Link to="/white-label-seo-services/" className="btn-brand">
          Get Started
        </Link>
      </div>
  </StyledPartners>
    </Section>
);
